import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { UseQueryResult, useQuery } from 'react-query';
import { UtilizationTotalClassesCountReport } from 'types/generated/models/UtilizationTotalClassesCountReport';
import { client } from 'utils/api-client';

function useTotalClasses(): UseQueryResult<AxiosResponse<UtilizationTotalClassesCountReport>> {
  const fetchTotalClasses = useCallback(() => client.get('/reports/utilization/total-classes'), []);

  return useQuery({
    queryKey: ['total-classes'],
    queryFn: fetchTotalClasses,
  });
}

export default useTotalClasses;
